export const AutosuggestTheme = {
  // Copied from example in https://github.com/moroshko/react-autosuggest/issues/359 with some edits
  container: { position: 'relative', top:'-4px' },
  input: {
    width: '100%',
    height: '20px',
    padding: '5px',
    fontWeight: 300,
    fontSize: 14,
    border: '1px solid #aaa',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
  inputFocused: { outline: 'none' },
  inputOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  suggestionsContainer: { display: 'none' },
  suggestionsContainerOpen: {
    width: '100%',
    display: 'block',
    position: 'absolute',
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: 300,
    fontSize: 16,
    zIndex: 2
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    maxHeight: '500px',
    overflowY: 'scroll'
  },
  suggestion: {
    cursor: 'pointer',
    padding: '2px'
  },
  suggestionHighlighted: { backgroundColor: '#ddd' }
};

export let AutosuggestThemeRed = {
  // Copied from example in https://github.com/moroshko/react-autosuggest/issues/359 with some edits
  container: { position: 'relative', top:'-4px' },
  input: {
    width: '100%',
    height: '20px',
    padding: '5px',
    fontWeight: 300,
    fontSize: 14,
    border: '1px solid #aaa',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderColor: 'red'
  },
  inputFocused: { outline: 'none' },
  inputOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  suggestionsContainer: { display: 'none' },
  suggestionsContainerOpen: {
    width: '100%',
    display: 'block',
    position: 'absolute',
    border: '1px solid #aaa',
    backgroundColor: '#fff',
    fontFamily: 'Helvetica, sans-serif',
    fontWeight: 300,
    fontSize: 16,
    zIndex: 2
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    maxHeight: '500px',
    overflowY: 'scroll'
  },
  suggestion: {
    cursor: 'pointer',
    padding: '2px'
  },
  suggestionHighlighted: { backgroundColor: '#ddd' }
};


// WEBPACK FOOTER //
// ./src/helpers/Themes.js